export enum Language {
  EN = 'en',
  CN = 'zh',
  HR = 'hr',
  CZ = 'cz',
  NL = 'nl',
  FI = 'fi',
  FR = 'fr',
  DA = 'da',
  DE = 'de',
  HU = 'hu',
  IT = 'it',
  JP = 'jp',
  KO = 'ko',
  NO = 'no',
  PL = 'pl',
  PT = 'pt',
  RO = 'ro',
  RU = 'ru',
  SL = 'sl',
  ES = 'es',
  SV = 'sv',
  TR = 'tr',
  VI = 'vi',
}

export const detectBrowserLanguage = (): Language => {
  let locale = Language.EN;

  Object.values(Language).forEach((v) => {
    if (navigator.language.match(new RegExp(v, 'i'))) {
      locale = v;
    }
  });

  return locale;
};
